<template>
  <!-- <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
      <div class="card-body p-15 p-sm-20 p-md-25">
        <div class="row">
          <div class="col-md-4 mb-20">
            <div class="form-group">
              <label>Zone:</label>
              <v-select
                class="custom-select-height"
                label="name"
                :options="ZonesList"
                v-model="zone_filter"
                @input="fetchLivs(zone_filter)"
              />
            </div>
          </div>
          <div class="col-md-4 mb-20">
            <div class="form-group">
              <label>Livreur :</label>
              <v-select
                class="custom-select-height"
                label="name"
                :options="LivreursList"
                v-model="liv_filter"
              >
              </v-select>
            </div>
          </div>
          <div class="col-md-4 mb-20">
            <div class="form-group">
              <label>Statut:</label>
              <select
                class="custom-select-height form-control"
                v-model="status_filter"
              >
                <option value="" selected>Status (Tous)</option>
                <option :value="0" selected>Nouveau</option>
                <option :value="1" selected>Enregistré</option>
                <option :value="2">Payé</option>
              </select>
            </div>
          </div>

          <div class="col-md-4 mb-20">
            <div class="form-group">
              <label>Par Date :</label>
             <rangedate-picker ref="myInput" v-model="date_filter" format="YYYY-MM-DD" i18n="EN"
                  :presetRanges="presetRanges" :captions="captions"></rangedate-picker>
            </div>
          </div>
          <div class="col-md-4 mb-20">
            <div class="form-group">
              <label>Créer par:</label>
              <v-select
                class="custom-select-height"
                v-model="created_filter"
                label="name"
                :options="CuserList"
                @search="onSearchUsers"
              >
              </v-select>
            </div>
          </div>
           <div class="col-md-4">
              <div class="form-group">
                <label>Chercher :</label>
                <input 
                  v-model="searchTerm"
                  class="form-control"
                  placeholder="Chercher">
                </input>
              </div>
            </div>
          <div class="col-md-4 mb-20">
            <button
              style="margin-top: 22px"
              class="btn btn-primary"
              @click="filter()"
            >
              <i class="flaticon-search" style="margin-right: 5px"></i>
              Filtrer
            </button>
            <button
              style="margin-top: 22px"
              class="btn btn-danger"
              @click="Removefilter()"
            >
              <i class="flaticon-close" style="margin-right: 5px"></i>
              Annuler
            </button>
          </div>
        </div>
      </div>
    </div> -->
  <div class="card mb-25 p-3 border-0 rounded-0 bg-white letter-spacing">
    <!-- <div class="row mb-20">
        <div class="col-md-6">
          <label>Voir</label>
          <v-select
            v-model="users.per_page"
            :options="[10, 25, 50, 100]"
            :clearable="false"
            class="per-page-selector d-inline-block mx-50"
            @update:modelValue="getRecords()"
          />
          <label>sur {{ users.total }} entités</label>
        </div>

        <div class="col-md-12">
          <div class="d-flex align-items-center justify-content-end">
            <input
              v-model="searchTerm"
              class="form-control"
              @change="filter()"
              placeholder="Chercher"
              @input="handleInput"
            />
          </div>
        </div>
      </div> -->

    <div class="col-md-12 mb-20 p-3">
      <router-link
        class="btn btn-primary"
        v-if="auth.can('ADD_BR_Z')"
        :to="{ name: 'AddReturnZonePage' }"
        style="margin-right: 12px"
      >
        Ajouter Bon de retour
      </router-link>
    </div>
    <br />

    <vue-good-table :columns="columns" :rows="rows" responsive>
      <template #emptystate>
        <center>Aucune entrées correspondants trouvés</center>
      </template>
      <template #table-row="props">
        <span v-if="props.column.field === 'note_ref'" class="text-nowrap">
          <b>{{ props.row.note_ref }}</b>
        </span>

        <span v-else-if="props.column.field === 'for_name'" class="text-nowrap">
          {{ props.row.for_name }}
        </span>

        <span
          v-else-if="props.column.field === 'created_at'"
          class="text-nowrap"
        >
          <template v-if="props.row.created_at != null">
            {{ getDate(props.row.created_at) }}<br/>
          </template>
          {{ props.row.by_name }}
        </span>
        <span
          v-else-if="props.column.field === 'recieveds'"
          class="text-nowrap"
        >
          {{ props.row.recieveds }} Colis
        </span>
        <span
          v-else-if="props.column.field === 'total_parcel'"
          class="text-nowrap"
        >
          {{ props.row.total_parcel }} Colis
        </span>
        <span
          v-else-if="props.column.field === 'transport'"
          class="text-nowrap"
        >
          <b>{{ props.row.transport }}</b>
          <small>{{ props.row.transport_code }}</small>
        </span>

        <template v-else-if="props.column.field === 'statut'">
          <span
            v-if="props.row.statut == 0 && props.row.total_parcel === 0"
            pill
            :class="`badge rounded-pill fs-13 text-bg-${resolveUserStatusVariant(
              4
            )}`"
          >
            Vide
          </span>
          <span
            v-if="props.row.statut == 0 && props.row.total_parcel !== 0"
            pill
            :class="`badge rounded-pill fs-13 text-bg-${resolveUserStatusVariant(
              props.row.statut
            )}`"
          >
            Nouveau
          </span>
          <span
            v-else-if="props.row.statut == 1"
            pill
            :class="`badge rounded-pill fs-13 text-bg-${resolveUserStatusVariant(
              props.row.statut
            )}`"
          >
            Enregistré
          </span>
          <span
            v-else-if="props.row.statut == 2"
            pill
            :class="`badge rounded-pill fs-13 text-bg-${resolveUserStatusVariant(
              props.row.statut
            )}`"
          >
            Expédier vers Agence Principale
          </span>
          <span
            v-else-if="props.row.statut == 3"
            pill
            :class="`badge rounded-pill fs-13 text-bg-${resolveUserStatusVariant(
              props.row.statut
            )}`"
          >
            Reçu par Agence Principale
          </span>
        </template>

        <template v-else-if="props.column.field === 'action'">
          <div class="dropdown">
            <button
              class="dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i class="flaticon-dots"></i>
            </button>
            <ul class="dropdown-menu">
              <li v-if="props.row.statut == 0">
                <router-link
                  class="dropdown-item"
                  :to="{
                    path: `/edit-return-zone/${props.row.id}/${props.row.note_ref}`,
                  }"
                >
                  <i
                    class="flaticon-edit lh-1 me-8 position-relative top-1"
                  ></i>
                  Modifier
                </router-link>
              </li>

              <li v-if="props.row.statut == 2">
                <router-link
                  class="dropdown-item"
                  :to="{
                    path: `/scan-return-zone/${props.row.id}/${props.row.note_ref}`,
                  }"
                >
                  <i
                    class="flaticon-edit lh-1 me-8 position-relative top-1"
                  ></i>
                  Modifier
                </router-link>
              </li>
              <li v-if="props.row.statut == 3">
                <router-link
                  class="dropdown-item"
                  :to="{
                    path: `/scan-return-zone/${props.row.id}/${props.row.note_ref}`,
                  }"
                >
                  <i
                    class="flaticon-view lh-1 me-8 position-relative top-1"
                  ></i>
                  Modifier
                </router-link>
              </li>

              <li
                v-if="
                  (props.row.statut == 0 && props.row.total_parcel == 0) ||
                  (props.row.statut != 0 && props.row.total_parcel == 0)
                "
              >
                <button class="dropdown-item" @click="DeleteNote(props.row)">
                  <i
                    class="flaticon-delete lh-1 me-8 position-relative top-1"
                  ></i>
                  Supprimer
                </button>
              </li>
              <li v-if="props.row.statut == 0 && props.row.total_parcel != 0">
                <button class="dropdown-item" @click="SaveBon(props.row)">
                  <i
                    class="flaticon-diskette lh-1 me-8 position-relative top-1"
                  ></i>
                  Enregistrer
                </button>
              </li>
              <li v-if="props.row.statut == 1 && props.row.total_parcel != 0">
                <button class="dropdown-item" @click="OpenBon(props.row)">
                  <i
                    class="flaticon-unlock lh-1 me-8 position-relative top-1"
                  ></i>
                  Ouvrir
                </button>
              </li>
              <li
                v-if="
                  props.row.statut == 2 &&
                  props.row.total_parcel != 0 &&
                  user.role_id == 1 &&
                  user.id == 1
                "
              >
                <button class="dropdown-item" @click="Unsent(props.row)">
                  <i
                    class="flaticon-unlock lh-1 me-8 position-relative top-1"
                  ></i>
                  Expedier vers Enregistré
                </button>
              </li>

              <li v-if="props.row.statut == 1 && props.row.total_parcel != 0">
                <button class="dropdown-item" @click="Transport(props.row)">
                  <i
                    class="flaticon-express-delivery lh-1 me-8 position-relative top-1"
                  ></i>
                  Expedier
                </button>
              </li>

              <!--<li
                 v-if="
                  props.row.statut == 3 &&
                  props.row.total_parcel != 0 &&
                  user.role_id == 1 &&
                  user.id == 1 &&
                  auth.can('VALIDATE_BR_Z')
                "
              >
                <button
                  class="dropdown-item"
                  @click="UnrecievedPaid(props.row)"
                >
                  <i
                    class="flaticon-close lh-1 me-8 position-relative top-1"
                  ></i>
                  Reçu vers Expédier
                </button>
              </li>
              <li
                v-if="
                  props.row.statut == 2 &&
                  props.row.total_parcel != 0 &&
                  auth.can('VALIDATE_BR_Z')
                "
              >
                <button class="dropdown-item" @click="BonPaid(props.row)">
                  <i
                    class="flaticon-check lh-1 me-8 position-relative top-1"
                  ></i>
                  Reçu
                </button>
              </li> -->
              <li>
                <button class="dropdown-item" @click="GetPDF(props.row)">
                  <i
                    class="flaticon-download lh-1 me-8 position-relative top-1"
                  ></i>
                  Télécharger le bon
                </button>
              </li>
              <li>
                <button class="dropdown-item" @click="TicketsPDF(props.row)">
                  <i
                    class="flaticon-grid lh-1 me-8 position-relative top-1"
                  ></i>
                  Voir étiquettes
                </button>
              </li>
              <!-- <li>
                <router-link
                  class="dropdown-item"
                  :to="{
                    name: 'timeline_note',
                    params: { id: props.row.id, ref: props.row.note_ref },
                  }"
                >
                  <i
                    class="flaticon-rotate lh-1 me-8 position-relative top-1"
                  ></i>
                  Historique bon
                </router-link>
              </li> -->
            </ul>
          </div>
        </template>

        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>
    </vue-good-table>
    <PaginatorContent
      :pagination="users"
      :offset="9"
      @paginate="getRecords"
    />
  </div>

  <div class="modal fade" id="modal_transport" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-xl">
      <div class="modal-content p-15 p-md-40">
        <div class="modal-header">
          <h1 class="modal-title fs-5">
            Expedier le bon : {{ TransRow?.note_ref }}
          </h1>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>

        <div class="modal-body">
          <form @submit.prevent="expedierBon(TransRow.id)">
            <div class="row">
              <div class="col-12 mb-20">
                <div
                  class="form-group"
                  label="Choisir Transport"
                  label-for="trans"
                >
                  <label for="driver">Transport</label>
                  <v-select
                    class="custom-select-height"
                    :options="transportList"
                    v-model="transport"
                    label="name"
                  >
                  </v-select>
                </div>
              </div>

              <div class="col-12 mb-20">
                <div
                  class="form-group"
                  label-for="name"
                  label="Le nombre de sacs"
                >
                  <label for="sacs">Le nombre de sacs</label>
                  <input
                    class="form-control"
                    v-model="sacs_transport"
                    name="sacs"
                    type="number"
                    min="0"
                  />
                </div>
              </div>

              <div class="col-md-12" v-if="transport?.type == 2">
                <div class="form-group" label-for="name" label="Code d\'envoie">
                  <label for="code_transport">Code d'envoie</label>
                  <input
                    class="form-control"
                    v-model="code_transport"
                    name="name"
                  />
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            data-bs-dismiss="modal"
          >
            Fermer
          </button>
          <button
            type="button"
            @click="expedierBon(TransRow.id)"
            class="btn btn-primary"
          >
            Enregistrer
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { ref, reactive } from "vue";
import { useAuthStore } from "@/stores/auth";
import moment from "moment";
import api from "@/utils/axios";
import { useAppToast } from "@/composables/useAppToast";
import router from "@/router";
import Swal from "sweetalert2";
import { onMounted } from "vue";
import { Modal } from "bootstrap";
export default defineComponent({
  setup() {
    const { showToast } = useAppToast();
    const auth = useAuthStore();
    const user = auth.user;

    const isLoader = ref(false);
    const columns = [
      {
        label: "Référence",
        field: "note_ref",
      },
      {
        label: "Date de création",
        field: "created_at",
      },
      {
        label: "Agence",
        field: "for_name",
      },
      {
        label: "Statut",
        field: "statut",
      },
      {
        label: "Colis",
        field: "total_parcel",
      },
      {
        label: "Reçu",
        field: "recieveds",
      },
      {
        label: "Transport",
        field: "transport",
      },
      {
        label: "Actions",
        field: "action",
      },
    ];
    const rows = ref([]);

    const pageLength = ref(10);
    const loading = ref(false);
    const searchTerm = ref("");
    const ZonesList = ref([]);
    const zone_filter = ref({ id: "", name: "" });
    const UsersList = ref([]);
    const user_filter = ref({ id: "", name: "" });
    const status_filter = ref("");
    const date_filter = ref("");
    const users = reactive({
      searchTerm: "",
      searchZone: "",
      searchUser: "",
      searchStatut: "",
      // searchDate: "",
      searchEDate: "",
      searchSDate: "",
      total: 0,
      per_page: 10,
      from: 1,
      to: 0,
      current_page: 1,
    });
    const offset = ref(9);
    const transportList = ref([]);
    const transport = ref<any>({});
    const TransRow = ref<any>({});
    const code_transport = ref("");
    const sacs_transport = ref("");
    const fees_transport = ref(null);
    const codeColis = ref("");

    const getDate = (value: string) => {
      return moment.utc(String(value)).format("YYYY-MM-DD HH:mm");
    };

    const resolveUserStatusVariant = (status) => {
      if (status === 0 || status === "0") return "danger";
      if (status === 1 || status === "1") return "info";
      if (status === 2 || status === "2") return "warning";
      if (status === 3 || status === "3") return "success";
      return "danger";
    };

    const filter = () => {
      users.searchZone = zone_filter.value.id;
      users.searchUser = user_filter.value.id;
      users.searchStatut = status_filter.value;
      //   users.searchSDate = date_filter.value?.start
      //     ? convert(date_filter.value.start)
      //     : '';
      //   users.searchEDate = date_filter.value?.end
      //     ? convert(date_filter.value.end)
      //     : '';
      users.current_page = 1;
      getRecords();
    };

    const Removefilter = () => {
      users.searchZone = "";
      users.searchUser = "";
      users.searchStatut = "";
      users.searchSDate = "";
      users.searchEDate = "";
      users.searchTerm = "";
      status_filter.value = "";
      date_filter.value = "";
      zone_filter.value = { id: "", name: "" };
      user_filter.value = { id: "", name: "" };
      // If you have liv_filter, reset it here too
      // liv_filter.value = { id: '', name: '' };
      users.current_page = 1;
      getRecords();
    };

    const getRecords = async (page = 1) => {
      isLoader.value = true;
      users.current_page = page;
      try {
        const response = await api.get(
          `/api/auth/brn_ag_list?searchTerm=${users.searchTerm}&searchUser=${users.searchUser}&searchZone=${users.searchZone}&searchStatut=${users.searchStatut}&searchSDate=${users.searchSDate}&searchEDate=${users.searchEDate}&page=${users.current_page}&per_page=${users.per_page}`,
          { params: { type: 1 } }
        );
        rows.value = response.data.users.data;
        Object.assign(users, response.data.users);
      } catch (error) {
        showToast("Erreur lors du chargement", "error");
      } finally {
        isLoader.value = false;
      }
    };

    let debounceTimer;
    const handleInput = () => {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        users.searchTerm = searchTerm.value;
        filter();
      }, 500);
    };

    const Transport = (row) => {
      transport.value = null;
      TransRow.value = null;

      code_transport.value = "";
      fees_transport.value = null;
      sacs_transport.value = "";

      // Declare TransRow and related variables before using them
      TransRow.value = row;

      const modalEl = document.getElementById("modal_transport");
      if (modalEl) {
        const modal = new Modal(modalEl);
        modal.show();
      }
    };

    const SaveBon = async (row) => {
      const data = new FormData();
      data.append("UserID", user.id);
      try {
        const result = await Swal.fire({
          text: "Vous voulez enregistrer ce bon ?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Oui, enregistrer!",
        });
        if (result.isConfirmed) {
          const res = await api.post(
            `/api/auth/save_rn_agency/${row.id}`,
            data
          );
          if (res.data.message === "success") {
            filter();
            showToast("Bon enregistré avec succès", "success");
          } else if (
            res.data.message === "not exist" ||
            res.data.message === "no parcel"
          ) {
            showToast("Vous pouvez pas enregistré ce bon", "error");
          } else if (res.data.message === "no transport") {
            showToast("Aucun transport trouvé !", "error");
          }
        }
      } catch {
        showToast("Une erreur est survenue", "error");
      }
    };

    const OpenBon = async (row) => {
      try {
        const res = await api.post(`/api/auth/unsave_rn_agency/${row.id}`);
        if (res.data.message === "success") {
          filter();
          showToast("Bon ouvert avec succès", "success");
        } else if (
          res.data.message === "not exist" ||
          res.data.message === "no parcel"
        ) {
          showToast("Vous pouvez pas ouvrir ce bon", "error");
        } else {
          showToast("Un erreur !", "error");
        }
      } catch {
        showToast("Une erreur est survenue", "error");
      }
    };

    const Unsent = async (row) => {
      try {
        const result = await Swal.fire({
          text: "Vous voulez modifier l'état de ce bon ?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Oui, Modifier!",
        });
        if (result.isConfirmed) {
          const res = await api.post(`/api/auth/unsent_note_rn/${row.id}`);
          if (res.data.message === "success") {
            filter();
            showToast("Bon modifié avec succès", "success");
          } else if (
            res.data.message === "not exist" ||
            res.data.message === "no parcel"
          ) {
            showToast("Vous pouvez pas modifier ce bon", "error");
          } else {
            showToast("Un erreur !", "error");
          }
        }
      } catch {
        showToast("Une erreur est survenue", "error");
      }
    };

    const UnrecievedPaid = async (row) => {
      try {
        const result = await Swal.fire({
          text: "Vous voulez modifier l'état de ce bon ?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Oui, Modifier!",
        });
        if (result.isConfirmed) {
          const res = await api.post(`/api/auth/unreceived_rn/${row.id}`);
          if (res.data.message === "success") {
            filter();
            showToast("Bon modifié avec succès", "success");
          } else if (
            res.data.message === "not exist" ||
            res.data.message === "no parcel"
          ) {
            showToast("Vous pouvez pas modifier ce bon", "error");
          } else {
            showToast(res.data.message, "error");
          }
        }
      } catch {
        showToast("Une erreur est survenue", "error");
      }
    };

    const BonPaid = async (row) => {
      try {
        const res = await api.post(`/api/auth/Paid_rn_agency/${row.id}`);
        if (res.data.message === "success") {
          filter();
          showToast("Bon transformé avec succès", "success");
        } else if (
          res.data.message === "not exist" ||
          res.data.message === "no parcel"
        ) {
          showToast("Vous pouvez pas transformer ce bon", "error");
        } else {
          showToast(res.data.message, "error");
        }
      } catch {
        showToast("Une erreur est survenue", "error");
      }
    };

    const expedierBon = async (row) => {
      if (Object.keys(transport.value).length !== 0) {
        const data = new FormData();
        data.append("UserID", user.id);
        data.append("trans_id", transport.value.id);
        data.append("trans_name", transport.value.name);
        data.append("code_transport", code_transport.value);
        data.append("sacs_transport", sacs_transport.value);
        data.append("fees_transport", fees_transport.value);
        try {
          const result = await Swal.fire({
            text: "Vous voulez expédier ce bon ?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Oui, expédier!",
          });
          if (result.isConfirmed) {
            const res = await api.post(
              `/api/auth/expedier_rn_zone/${row.id}`,
              data
            );
            if (res.data.message === "success") {
              const modalEl = document.getElementById("modal_transport");
              if (modalEl) {
                const modal = new Modal(modalEl);
                modal.hide();
              }
              filter();
              showToast("Bon expédié avec succès", "success");
            } else if (
              res.data.message === "not exist" ||
              res.data.message === "no parcel"
            ) {
              showToast("Vous pouvez pas enregistré ce bon", "error");
            } else if (res.data.message === "no transport") {
              showToast("Aucun transport trouvé !", "error");
            }
          }
        } catch {
          showToast("Une erreur est survenue", "error");
        }
      } else {
        showToast("Champs transport est obligatoire", "error");
      }
    };

    const GetPDF = async (row) => {
      try {
        const response = await api.get(`/api/auth/ReturnPDF/${row.id}`, {
          responseType: "arraybuffer",
        });
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        window.open(link.href, "_blank");
      } catch {
        showToast("Erreur lors du téléchargement du PDF", "error");
      }
    };

    const TicketsPDF = async (row) => {
      try {
        const response = await api.get(`/api/auth/TicketReturnPDF/${row.id}`, {
          responseType: "arraybuffer",
        });
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        window.open(link.href, "_blank");
      } catch {
        showToast("Erreur lors du téléchargement des étiquettes", "error");
      }
    };

    const DeleteNote = async (row) => {
      try {
        const result = await Swal.fire({
          text: "Vous voulez vraiment supprimer ce bon ?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Oui, supprimer!",
        });
        if (result.isConfirmed) {
          const res = await api.post(
            `/api/auth/RemoveNoteRN/${row.id}/${row.note_ref}`
          );
          if (res.data.message === "success") {
            filter();
            showToast("Le bon est bien supprimé", "success");
          } else if (
            res.data.message === "not exist" ||
            res.data.message === "no edit"
          ) {
            showToast("Vous pouvez pas supprimer ce bon!", "error");
          }
        }
      } catch {
        showToast("Une erreur est survenue", "error");
      }
    };

    const ScanRecuColis = async () => {
      const data = new FormData();
      data.append("code_colis", codeColis.value);
      try {
        const res = await api.post(`/api/auth/globalScanColis`, data);
        codeColis.value = "";
        if (res.data.message === "success") {
          filter();
          showToast("Colis bien ajouté", "success");
        } else if (res.data.message === "not exist") {
          showToast("Colis n'existe pas", "error");
        } else {
          showToast("Vous pouvez pas ajouter ce colis", "error");
        }
      } catch {
        showToast("Une erreur est survenue", "error");
      }
    };

    const ExportNotes = async () => {
      users.searchZone = zone_filter.value.id;
      users.searchUser = user_filter.value.id;
      users.searchStatut = status_filter.value;
      //   users.searchSDate = date_filter.value?.start
      //     ? convert(date_filter.value.start)
      //     : '';
      //   users.searchEDate = date_filter.value?.end
      //     ? convert(date_filter.value.end)
      //     : '';
      try {
        const res = await api.get(
          `/api/auth/exportReturns?searchTerm=${users.searchTerm}&searchUser=${users.searchUser}&searchZone=${users.searchZone}&searchStatut=${users.searchStatut}&searchSDate=${users.searchSDate}&searchEDate=${users.searchEDate}&type=1`,
          { responseType: "arraybuffer" }
        );
        const fileURL = window.URL.createObjectURL(
          new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          })
        );
        const fileLink = document.createElement("a");
        fileLink.href = fileURL;
        fileLink.download = "ExportReturns.xlsx";
        fileLink.click();
        showToast("Export réussi", "success");
      } catch {
        showToast("Erreur lors de l'export", "error");
      }
    };

    const convert = (str) => {
      const date = new Date(str);
      const mnth = `0${date.getMonth() + 1}`.slice(-2);
      const day = `0${date.getDate()}`.slice(-2);
      return [date.getFullYear(), mnth, day].join("-");
    };

    onMounted(async () => {
      getRecords();
      try {
        const response = await api.get("/api/auth/agency");
        ZonesList.value = response.data;
        ZonesList.value.unshift({ id: "", name: "Tous" });
      } catch {
        showToast("Erreur lors du chargement des zones", "error");
      }

      try {
        const response = await api.get("/api/auth/ActiveTransportList");
        transportList.value = response.data;
      } catch {
        showToast("Erreur lors du chargement des transports", "error");
      }
    });

    return {
      auth,
      user,
      isLoader,
      columns,
      rows,
      getDate,
      getRecords,
      pageLength,
      loading,
      searchTerm,
      handleInput,
      ZonesList,
      zone_filter,
      UsersList,
      user_filter,
      status_filter,
      date_filter,
      users,
      offset,
      filter,
      Removefilter,
      transport,
      ScanRecuColis,
      ExportNotes,
      expedierBon,
      BonPaid,
      UnrecievedPaid,
      Unsent,
      OpenBon,
      SaveBon,
      GetPDF,
      TicketsPDF,
      DeleteNote,
      resolveUserStatusVariant,
      TransRow,
      code_transport,
      sacs_transport,
      codeColis,
      Transport,
      transportList,
    };
  },
});
</script>
